module.exports = __webpack_public_path__ + "r-v3/img/icon_video_off.f1e23a53.svg";